module.exports = __webpack_public_path__ + "static/media/home-caro-4.a22e93ff.png";